// DarwinUpload.tsx
import { Upload } from 'antd';
import type { UploadProps, UploadFile } from 'antd/es/upload/interface';

export interface DUploadProps extends UploadProps {}

export const DarwinUpload = Object.assign(
  (props: DUploadProps) => <Upload {...props} />,
  {
    LIST_IGNORE: Upload.LIST_IGNORE,
  }
);

export type { UploadProps, UploadFile };
